import { render, staticRenderFns } from "./examChunk.vue?vue&type=template&id=57690754&scoped=true"
import script from "./examChunk.vue?vue&type=script&lang=js"
export * from "./examChunk.vue?vue&type=script&lang=js"
import style0 from "./examChunk.vue?vue&type=style&index=0&id=57690754&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57690754",
  null
  
)

export default component.exports